module.exports = __webpack_public_path__ + "img/hotdog-top-sra001.750c27d2.jpg";